import styled from "styled-components";

export const Content = styled.div`
  width: 880px;
  max-width: 100%;
  max-height: 60vh;
  overflow-y: auto;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 16px 12px;

  span {
    font-size: 12.5px;
    color: ${(props) => props.theme.brand.soft};
    font-variant-numeric: tabular-nums;
  }
`;

export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid ${(props) => props.theme.brand.line};
  color: ${(props) => props.theme.brand.navy};
  font-size: 13px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover:not(:disabled) {
    border-color: #c0cfe0;
    background: #f5f8fb;
  }

  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
`;

const gridColumns = "minmax(0, 1fr) 180px 150px 150px";

export const ListHeader = styled.div`
  display: grid;
  grid-template-columns: ${gridColumns};
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eef1f5;
  background: #fafbfd;

  span {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${(props) => props.theme.brand.soft};
  }
`;

export const ListRow = styled.div`
  display: grid;
  grid-template-columns: ${gridColumns};
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f3f7;

  span {
    font-size: 13px;
    color: #3a4a5c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const UserCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const UserName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.brand.ink};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserEmail = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.brand.soft};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
